/**
 * Obtiene la fecha actual como objeto Date interpretado en zona horaria de Colombia (UTC-5).
 * El Date resultante tiene el mismo año/mes/día que en Colombia,
 * pero la hora está en la zona local del navegador.
 */
export function getColombiaDate(date = new Date()): Date {
  const colombiaStr = date.toLocaleString('en-US', { timeZone: 'America/Bogota' });
  return new Date(colombiaStr);
}

/**
 * Convierte una fecha a string YYYY-MM-DD en zona horaria de Colombia.
 * Útil para evitar desfases de fecha cuando el navegador está en otra zona.
 */
export function toColombiaDateString(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}

/**
 * Formatea una fecha como "hace X tiempo"
 */
export function formatDistanceToNow(date: string | Date): string {
  const now = new Date();
  const then = new Date(date);
  const seconds = Math.floor((now.getTime() - then.getTime()) / 1000);

  if (seconds < 60) {
    return 'hace un momento';
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `hace ${minutes} min`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `hace ${hours} h`;
  }

  const days = Math.floor(hours / 24);
  if (days < 30) {
    return `hace ${days} d`;
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    return `hace ${months} mes`;
  }

  const years = Math.floor(months / 12);
  return `hace ${years} años`;
}

/**
 * Formatea una fecha completa
 */
export function formatDate(date: string | Date): string {
  const d = new Date(date);
  return d.toLocaleDateString('es-CO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/**
 * Formatea una fecha y hora
 */
export function formatDateTime(date: string | Date): string {
  const d = new Date(date);
  return d.toLocaleString('es-CO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
